import React from 'react';
import { CSSTransitionGroup } from 'react-transition-group'
import PropTypes from 'prop-types';
import ImageContent from './Image';
import Button from './Button';
import { addClass, removeClass, classToggle } from './utils/classNames';
import iconPath from "../../../../../helpers/iconHelper";
import { Link } from 'react-router-dom';
import {encrypt} from "../../../../../helpers/CryptoJs"
import './Container.css'

const transitionTime = 300;
const transitionDelta = 50;
export default class Container extends React.Component {
  constructor(props) {
    super(props);

    this.handleLeftClick = this.handleLeftClick.bind(this);
    this.handleRightClick = this.handleRightClick.bind(this);
    this.canMoveToLeft = this.canMoveToLeft.bind(this);
    this.canMoveToRight = this.canMoveToRight.bind(this);
    this.toggleControls = this.toggleControls.bind(this);
    this.handleKeyboard = this.handleKeyboard.bind(this);
    this.getDescriptions = this.getDescriptions.bind(this);
    this.state = {
      selectedImageIndex: props.selectedImage,
      direction: 'none',
      imagesDescriptions: {},
      scrollposition    : 0,
    };
  }

  getDescriptions(){
    let images = this.state.imagesDescriptions;
    this.props.images.forEach((image, index) => {
      if(!image.description) return;
      if(image.description.then){ //if promise
        image.description.then((data) => {
          images[index] = data;
          this.setState({imagesDescriptions: images});
        });
        return;
      }
      images[index] = image.description;
      this.setState({imagesDescriptions: images});
    });
  }

  componentDidMount() {
    let scroll = window.scrollY;
    this.setState({
      scrollposition : scroll
    });
    this.getDescriptions();
    document.addEventListener('keydown', this.handleKeyboard);
    const scrollTop = document.body.scrollTop;
    addClass(document.documentElement, 'lightbox-open');
    document.documentElement.style.top = `-${scrollTop}px`;
    document.body.scroll = "no"; // ie only
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyboard);
    const scrollTop = Math.abs(parseInt(document.documentElement.style.top, 10))
    removeClass(document.documentElement, 'lightbox-open');
    document.documentElement.style.top = null;
    document.body.scrollTop = scrollTop
    document.body.scroll = "yes"; // ie only
    window.scroll(0, this.state.scrollposition);
  }

  handleKeyboard(ev) {
    const key = ev.keyCode ? ev.keyCode : ev.which;
    if(this.timeLastTransition &&
      ((new Date()) - this.timeLastTransition) < transitionTime + transitionDelta) {
      return;
    }
    this.timeLastTransition = new Date();
    switch(key){
      case 37:
        return this.handleLeftClick();
      case 39:
        return this.handleRightClick();
      case 27:
        return this.props.toggleLightbox();
      default:
        break;
    }
  }

  handleLeftClick(){
    if (this.canMoveToLeft()) {
      this.setState({
        selectedImageIndex: (this.state.selectedImageIndex - 1),
        direction: 'left'
      });
    };
  }

  handleRightClick(){
    if (this.canMoveToRight()) {
      this.setState({
        selectedImageIndex: (this.state.selectedImageIndex + 1),
        direction: 'right'
      });
    };
  }

  canMoveToLeft() {
    return (this.state.selectedImageIndex > 0)
  }

  canMoveToRight() {
    return (this.state.selectedImageIndex < (this.props.images.length - 1))
  }

  toggleControls() {
    classToggle(this.refs.container, 'hide-controls')
  }

  render() {
    let [props, state] = [this.props, this.state];
    let image = props.images[state.selectedImageIndex];
    
    let leftButton, rightButton;
    let descriptionText = state.imagesDescriptions[state.selectedImageIndex];
    let description = props.renderDescriptionFunc.call(this, descriptionText);
    const transitionName = 'lightbox-transition-image';

    let linkid  = '';
    let likeimage  = '';
    let like    = 0;
    let comment = 0;
    let share   = 0;

    if(this.props.position == 'album'){
      if(props.imageList[this.state.selectedImageIndex].my_reaction != null){
        likeimage  = iconPath[props.imageList[this.state.selectedImageIndex].my_reaction]
      }else{
        likeimage  = '/assets/images/like_dislike_goldspace.png';
      }
      like         = parseInt((props.imageList[this.state.selectedImageIndex].total_like != null) ? props.imageList[this.state.selectedImageIndex].total_like : 0) + 
                     parseInt((props.imageList[this.state.selectedImageIndex].total_angry != null) ? props.imageList[this.state.selectedImageIndex].total_angry : 0) + 
                     parseInt((props.imageList[this.state.selectedImageIndex].total_breakheart != null) ? props.imageList[this.state.selectedImageIndex].total_breakheart : 0) + 
                     parseInt((props.imageList[this.state.selectedImageIndex].total_dislike  != null) ? props.imageList[this.state.selectedImageIndex].total_dislike : 0) + 
                     parseInt((props.imageList[this.state.selectedImageIndex].total_laugh  != null) ? props.imageList[this.state.selectedImageIndex].total_laugh : 0) +  
                     parseInt((props.imageList[this.state.selectedImageIndex].total_sad != null) ? props.imageList[this.state.selectedImageIndex].total_sad : 0);
      comment      = props.imageList[this.state.selectedImageIndex].total_comment;
      share        = props.imageList[this.state.selectedImageIndex].total_share;
      linkid       = props.imageList[this.state.selectedImageIndex].media_id;
    }else if(this.props.position == 'dedicates'){
        if(props.imageList[this.state.selectedImageIndex].my_reaction != null){
        likeimage  = iconPath[props.imageList[this.state.selectedImageIndex].my_reaction]
      }else{
        likeimage  = '/assets/images/like_dislike_goldspace.png';
      }

      like         = props.imageList[this.state.selectedImageIndex].total_reaction;
      comment      = props.imageList[this.state.selectedImageIndex].total_comment;
      share        = props.imageList[this.state.selectedImageIndex].total_share;
      linkid       = props.imageList[this.state.selectedImageIndex].gallery_id;
    }else if(this.props.position == 'uploads'){
      if(props.imageList[this.state.selectedImageIndex].my_reaction != null){
        likeimage  = iconPath[props.imageList[this.state.selectedImageIndex].my_reaction]
      }else{
        likeimage  = '/assets/images/like_dislike_goldspace.png';
      }

      like         = props.imageList[this.state.selectedImageIndex].total_reaction;
      comment      = props.imageList[this.state.selectedImageIndex].total_comment;
      share        = props.imageList[this.state.selectedImageIndex].total_share;
      linkid       = props.imageList[this.state.selectedImageIndex].gallery_id;
    }else{
  
      likeimage    = '/assets/images/like_dislike_goldspace.png';
      like         = props.post_total_reaction;
      comment      = props.post_total_comment;
      share        = props.post_total_share;
      linkid       = props.imageList[this.state.selectedImageIndex].gallery_id;
    }
    if(this.canMoveToLeft())
      leftButton = (
        <div className='lightbox-btn-left'>
          <Button icon="left-arrow" onClick={this.handleLeftClick} size={ 56 } hasRipple={ true } />
        </div>
      )
    if(this.canMoveToRight())
      rightButton = (
        <div className='lightbox-btn-right'>
          <Button icon="right-arrow" onClick={this.handleRightClick} size={ 56 } hasRipple={ true } />
        </div>
      )
    return (
      <div className='lightbox-backdrop' ref='container'>
        <div className='lightbox-btn-close'>
          <Button icon="close" onClick={props.toggleLightbox} size={ 34 } hasRipple={ true } />
        </div>
        <div className='lightbox-title-content'>
          <div className='lightbox-title'>
            <div className="modal_actions_icons">
             
                <div className="col-lg-4">
                  <a href={`/media/${encrypt(linkid)}`}>
                  <div className="btn-toolbar">
                    {
                        <img width="26px" src={likeimage} /> 
                    }
                  </div>
                  
                    <div className="view_all_like" href={void(0)}>
                      {
                        (like == null) ? 0 : like 
                      }
                    </div>  
                  </a>
                </div>
                <div className="col-lg-4">
                <a href={`/media/${encrypt(linkid)}`}>
                  <div className="btn-toolbar">
                    <img width="26px" src={iconPath['FEEDCOMMENT']}/>
                  </div>
                  <div className="view_all_like" >
                    {
                      (comment == null) ? 0 : comment 
                    }
                    
                  </div> 
                </a>
                </div>
                <div className="col-lg-4 checkApp" >
                <a href={`/media/${encrypt(linkid)}`}>
                  <div className="btn-toolbar">
                    <img width="26px" src={iconPath['FEEDSHARE']}/>
                  </div>
                  <div className="view_all_like" href={void(0)}>
                    {
                   
                      (share == null) ? 0 : share 
                    }
                     
                  </div> 
                  </a>
                </div>
             
            </div>
          </div>
         
        </div>
       
          <ImageContent key={image.media_link}
                        src={image.media_link}
                        type={image.media_type}
                        showImageModifiers={props.showImageModifiers}
                        toggleControls={this.toggleControls} />
        
        {leftButton}
        {rightButton}
      </div>
    )
  }
}

Container.defaultProps = {
  selectedImage: 0,
  renderDescriptionFunc: (descriptionText) => {
    return (
      <div>
        {String(descriptionText)}
      </div>
    )
  }
}

Container.propTypes = {
  selectedImage: PropTypes.number,
  images: PropTypes.array.isRequired,
  toggleLightbox: PropTypes.func.isRequired,
  showImageModifiers: PropTypes.bool,
  renderDescriptionFunc: PropTypes.func
}
